<template>
	<sacleBox>
		<!-- 模拟数据开关：仅对 MOCK_SCHOOL_GUIDS 中的院校显示 -->
		<div v-if="mockEnable" class="openclosebtn" @click.stop="openbtnshowtext">{{ openbtntext ? '关闭' : '开启' }}</div>
		<div class="appconten">
			<div class="appleft">
				<div class="applefttitle">
					<p class="lefttitilefonts">// 累计实训时长数据 //</p>
					<p class="fontsanum"><numbergrow :value="alltrainsnumobj.trainTime"></numbergrow></p>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">设备预约排行榜</p>
				</div>
				<div class="trainsb monitor">
					<ul>
						<li>
							<p style="background-color: transparent;">排名</p>
							<p style="width: 45%;">设备名称</p>
							<p style="width: 25%;">预约次数</p>
							<p style="width: 22%;">占比</p>
						</li>
					</ul>
					<div style="overflow: hidden;">
						<vueSeamlessScroll v-if="deviceranklist.length > 0" :data="deviceranklist" class="seamless-warp" :class-option="classOption">
							<ul>
								<li v-for="(item, index) in deviceranklist" :key="index">
									<p>{{ index + 1 }}</p>
									<p style="width: 45%;" :title="item.te_deviceName">{{ item.te_deviceName }}</p>
									<p style="width: 25%;">{{ item.count }}</p>
									<p style="width: 22%;">{{ item.percent }}%</p>
								</li>
							</ul>
						</vueSeamlessScroll>
					</div>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">班级实训排行榜</p>
				</div>
				<div class="trainsb monitor">
					<ul>
						<li>
							<p style="background-color: transparent;">排名</p>
							<p style="width:45%;">班级名称</p>
							<p style="width:30%;">累计时长（小时）</p>
							<p style="width:15%;">合格率</p>
						</li>
					</ul>
					<div style="overflow: hidden;">
						<vueSeamlessScroll v-if="appointmentlist.length > 0" :data="appointmentlist" class="seamless-warp" :class-option="classOption1">
							<ul>
								<li v-for="(item, index) in appointmentlist" :key="index">
									<p style="width: 10%;margin-right: 20px;">{{ index + 1 }}</p>
									<p style="width:45%;" :title="item.cla_name">{{ item.cla_name }}</p>
									<p style="width:30%;">{{ item.LengthOfTimeSeconds }}</p>
									<p style="width:15%;display: flex;align-items: center;justify-content: center;">
										<span>{{ item.pPercent }}%</span>
									</p>
								</li>
							</ul>
						</vueSeamlessScroll>
					</div>
				</div>

				<div style="width: 100%;height: 25%;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">本周实训人数统计</p>
					</div>
					<div class="nomolflex trainspic3" id="pic4"></div>
				</div>
			</div>
			<img src="../../images/chartline.png" class="lines" alt="这是一条线" />
			<div class="appcenter">
				<div class="trainstitle">
					<img src="../../images/datetopbgg.png" alt="" />
					<p>实训智能管理中心</p>
				</div>
				<div class="trainsweather nomolflex">
					<div class="trainsbox">
						<div class="trainsboxleft">
							<p>{{ nowTime }}</p>
							<p style="padding-left: 10px;">{{ yeartimer }}</p>
						</div>
						<div class="trainsboxright">
							<img style="width: 40%;" v-if="weatherobj.weatherimg" :src="weatherobj.weatherimg" alt="" />
							<p class="comenteflex" style="margin-left: 24px; color: rgb(205, 221, 247);">
								<span>{{ weatherobj.weather }}</span>
								<!-- &nbsp;&nbsp;{{ weatherobj.winddirection }}风 -->
								<span>{{ weatherobj.temperature }}℃</span>
								<span>{{ autolocation.city }}</span>
							</p>
						</div>
					</div>
					<img class="dataline" src="../../images/dataline.png" alt="" />
					<div class="trainsall">
						<p>实训室总数：{{ alltrainsnumobj.trainCount }} 个</p>
						<p style="color: #7FFF00;">实训设备总数：{{ alltrainsnumobj.trainECount }} 套</p>
						<p style="color: #7FFFD4;">实训人数：{{ alltrainsnumobj.trainPCount }} 人</p>
					</div>
				</div>
				<div class="nomolflex trainsimg"><div class="nomolflex trainspic2" id="pic2"></div></div>
			</div>
			<img src="../../images/chartline.png" class="lines" alt="这是一条线" />
			<div class="appright">
				<div style="width: 100%;height: 26%;margin-bottom: 10px;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">设备使用率分析</p>
					</div>
					<div class="nomolflex trainspic3" id="pic3"></div>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">实训设备状态分析</p>
				</div>

				<div class="applefecharts"><div class="echartsa" id="pic1" ref="pic1"></div></div>

				<div style="width: 100%;height: 50%;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">实时预约数据</p>
					</div>
					<div class="traingety">
						<ul>
							<li class="nomolflex">
								<p>姓名</p>
								<p>预约设备</p>
								<p>实训时间</p>
							</li>
						</ul>

						<div style="overflow: hidden;" class="scrols" @click="handleClick($event)">
							<vueSeamlessScroll v-if="appoindatalist.length > 0" :data="appoindatalist" class="seamless-warp" :class-option="classOption3">
								<ul style="margin-top: 0;">
									<li class="nomolflex listItem" v-for="(item, index) in appoindatalist" :key="index" :data="JSON.stringify(item)">
										<p>{{ item.ui_realName }}</p>
										<p>{{ item.tr_name }}({{ item.te_deviceName }})</p>
										<p>{{ item.ap_appDate }}</p>
									</li>
								</ul>
							</vueSeamlessScroll>
						</div>
					</div>
				</div>
			</div>
		</div>
	</sacleBox>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

import 'echarts/lib/chart/bar';
import vueSeamlessScroll from 'vue-seamless-scroll';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import $ from 'jquery';
import {
	DataWallGetTrainSTA, //实训统计数据
	GetTrainSTANewAPI, // 新实训统计数据
	DataWallGetTrainCount, // 获取本周实训人数统计
	GetTrainCountNewCountApi, // 新获取本周实训人数统计
	GetTrainEquipmentStatusSTA,
	GetTrainUsageSTA,
	GetTrainSingleDataList, // 个人实训排行榜
	GetTrainSingleDataListNewApi, // 新个人实训排行榜
	GetTrainClassDataList, // 班级实训
	GetTrainClassDataListNewAPi, // 新班级实训排行榜
	GetPageAppointDataList,
	GetTrainTimeLengthDataList, //设备实训时长统计
	GetTrainTimeLengthDataListNewApi // 新设备实训时长统计
} from '@/request/alllog.js';
$('.appconten').outerHeight($(document).outerHeight());
$('.appright').outerHeight($(document).outerHeight());

import { getCity, getweathers } from '@/utils/requestweather.js';

import sacleBox from '@/components/sacleBox.vue';

import AMap from 'AMap';

// ==================== 数据墙模拟数据（开启 / 关闭 开关） ====================
// 需要展示「开启 / 关闭」模拟数据开关的院校 si_guid，按需往数组里追加。
// 若按钮没出现：控制台执行 localStorage.getItem('siguid') 拿到当前院校 guid 加进来，
// 或执行 localStorage.setItem('datawallMock', '1') 后刷新，强制打开开关。
const MOCK_SCHOOL_GUIDS = [
	'f760369023c3453bb0917c0869260187',
	'86f7b581e9cd4613bc58e76c3cc8cf3d',
	'a4c15b121b2b4e82841a2eea30441c10',
	'71f98248c0f5480cb0a99b0dbc761c31'
];

// 设备实训时长模拟数据：按「当前年份」动态生成最近 MOCK_YEAR_SPAN 年，
// 当年只填到当前月份、之后月份为 0，避免出现"未来数据"。
// 需要改成年份区间长度，只改 MOCK_YEAR_SPAN 即可。
const MOCK_YEAR_SPAN = 4;
const MOCK_DEVICES = ['驾驶台1', '驾驶台2', '驾驶台3'];

function buildListyearsData(seed) {
	const pad = n => (n < 10 ? '0' + n : '' + n);
	const now = new Date();
	const curYear = now.getFullYear();
	const curMonth = now.getMonth() + 1;

	// 最近 MOCK_YEAR_SPAN 年（含今年），升序
	const years = [];
	for (let i = MOCK_YEAR_SPAN - 1; i >= 0; i--) {
		years.push(curYear - i);
	}

	// 按设备的逐月数据
	const listyear = MOCK_DEVICES.map((deviceName, deviceIndex) => {
		const item = { te_deviceName: deviceName };
		years.forEach((year, yearIndex) => {
			// 每个设备每一年的基准值略有差异
			const base = 58 + ((seed * 5 + yearIndex * 7 + deviceIndex * 9) % 11);
			for (let month = 1; month <= 12; month++) {
				let value = 0;
				// 用正弦波做平滑的月度起伏，避免月份之间出现锯齿式跳变
				const wave = Math.round(13 * Math.sin((month + yearIndex * 2 + deviceIndex * 3 + seed) / 1.9));
				// 往年全年都有数据；今年只填到当前月份，之后的月份保持 0
				if (year < curYear || month <= curMonth) {
					value = base + wave;
				}
				item[year + '-' + pad(month)] = value;
			}
		});
		return item;
	});

	// 每年的设备汇总（饼图用）
	const listYear = {};
	years.forEach((year, yearIndex) => {
		listYear[String(year)] = MOCK_DEVICES.map((deviceName, deviceIndex) => ({
			te_deviceName: null,
			te_deviceNumber: deviceName,
			count: 18 + ((seed * 7 + yearIndex * 11 + deviceIndex * 9) % 26),
			accounted: 40 + ((seed * 5 + yearIndex * 13 + deviceIndex * 7) % 56),
			year: year
		}));
	});

	return { listyear: listyear, listYear: listYear };
}

// 模拟数据方案一：模拟驾驶台
function mockDataDrive() {
	return {
		// 本周实训人数统计（周一 ~ 周日）
		datacountlist: [52, 48, 61, 45, 70, 38, 26],
		// 累计实训时长 / 实训室总数 / 实训设备总数 / 实训人数
		alltrainsnumobj: { trainTime: 1500, trainCount: 6, trainECount: 12, trainPCount: 128 },
		// 个人实训排行榜
		userslist: [
			{ ui_realName: '吴廷杰', LengthOfTimeSeconds: 48, sScore: 10 },
			{ ui_realName: '任俊帆', LengthOfTimeSeconds: 41, sScore: 9.6 },
			{ ui_realName: '高研', LengthOfTimeSeconds: 33, sScore: 9.2 },
			{ ui_realName: '李嘉兴', LengthOfTimeSeconds: 38, sScore: 8.5 },
			{ ui_realName: '潘乃新', LengthOfTimeSeconds: 40, sScore: 7.9 },
			{ ui_realName: '李钰白', LengthOfTimeSeconds: 44, sScore: 7.2 },
			{ ui_realName: '王博英', LengthOfTimeSeconds: 48, sScore: 6.6 },
			{ ui_realName: '金铃', LengthOfTimeSeconds: 39, sScore: 5.4 },
			{ ui_realName: '吴廷杰', LengthOfTimeSeconds: 36, sScore: 4.8 },
			{ ui_realName: '吴耀华', LengthOfTimeSeconds: 31, sScore: 3.4 }
		],
		// 实时预约数据
		appoindatalist: [
			{ ui_realName: '吴廷杰', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '任俊帆', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '高研', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '李嘉兴', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' },
			{ ui_realName: '潘乃新', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' },
			{ ui_realName: '李钰白', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' },
			{ ui_realName: '王博英', tr_name: '模拟驾驶台', te_deviceName: '驾驶台3' },
			{ ui_realName: '金铃', tr_name: '模拟驾驶台', te_deviceName: '驾驶台3' },
			{ ui_realName: '吴耀华', tr_name: '模拟驾驶台', te_deviceName: '驾驶台3' }
		],
		// 使用时长分析
		listyearsData: buildListyearsData(0)
	};
}

// 模拟数据方案二：通用演示数据
function mockDataCommon() {
	return {
		datacountlist: [38, 42, 35, 50, 44, 22, 18],
		alltrainsnumobj: { trainTime: 800, trainCount: 4, trainECount: 8, trainPCount: 76 },
		userslist: [
			{ ui_realName: '张伟', LengthOfTimeSeconds: 35, sScore: 8.5 },
			{ ui_realName: '李娜', LengthOfTimeSeconds: 30, sScore: 7.8 },
			{ ui_realName: '王磊', LengthOfTimeSeconds: 28, sScore: 6.5 },
			{ ui_realName: '刘洋', LengthOfTimeSeconds: 25, sScore: 5.2 },
			{ ui_realName: '陈静', LengthOfTimeSeconds: 22, sScore: 4.8 },
			{ ui_realName: '赵鑫', LengthOfTimeSeconds: 20, sScore: 3.6 },
			{ ui_realName: '孙婷', LengthOfTimeSeconds: 18, sScore: 2.9 },
			{ ui_realName: '周强', LengthOfTimeSeconds: 15, sScore: 2.1 },
			{ ui_realName: '吴敏', LengthOfTimeSeconds: 12, sScore: 1.8 },
			{ ui_realName: '郑浩', LengthOfTimeSeconds: 10, sScore: 1.2 }
		],
		appoindatalist: [
			{ ui_realName: '张伟', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '李娜', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '王磊', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' },
			{ ui_realName: '刘洋', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' },
			{ ui_realName: '陈静', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '赵鑫', tr_name: '模拟驾驶台', te_deviceName: '驾驶台3' },
			{ ui_realName: '孙婷', tr_name: '模拟驾驶台', te_deviceName: '驾驶台3' },
			{ ui_realName: '周强', tr_name: '模拟驾驶台', te_deviceName: '驾驶台1' },
			{ ui_realName: '吴敏', tr_name: '模拟驾驶台', te_deviceName: '驾驶台2' }
		],
		listyearsData: buildListyearsData(1)
	};
}

// 院校 guid -> 模拟数据
function getMockDataMap() {
	return {
		'f760369023c3453bb0917c0869260187': mockDataDrive(),
		'86f7b581e9cd4613bc58e76c3cc8cf3d': mockDataCommon(),
		'a4c15b121b2b4e82841a2eea30441c10': mockDataCommon(),
		'71f98248c0f5480cb0a99b0dbc761c31': mockDataCommon()
	};
}
// ==================== 数据墙模拟数据 end ====================

export default {
	data() {
		return {
			weatherobj: {},
			dataMap: {},
			myCharts2: {},
			myCharts3: {},
			myCharts4: {},
			listLenght: 6,
			// 设备预约排行榜（静态展示数据，按需直接改这里的数字）
			deviceranklist: [
				{ te_deviceName: 'CTC调度室', count: 186, percent: 21 },
				{ te_deviceName: '列车调度室', count: 162, percent: 19 },
				{ te_deviceName: '车站值班室', count: 148, percent: 17 },
				{ te_deviceName: '信号联锁室', count: 121, percent: 14 },
				{ te_deviceName: '区间闭塞室', count: 96, percent: 11 },
				{ te_deviceName: '模拟驾驶室', count: 74, percent: 8 },
				{ te_deviceName: '牵引供电室', count: 52, percent: 6 },
				{ te_deviceName: '工务演练室', count: 33, percent: 4 }
			],
			appointmentlist: [],

			// 时间
			timer: '', //定义一个定时器
			usertimers: '',
			nowTime: '',
			yeartimer: '',
			years: new Date().getFullYear(),
			option1: {
				legend: {
					show: true,
					right: '10%',
					orient: 'vertical',
					bottom: '30%',
					textStyle: {
						color: '#fff'
					},
					formatter: function(val, idx) {
						// console.log(val, idx, '获取顶部信息信息');
						// var htmls = '';
						// if (val === '维修中') {
						// 	htmls =
						// 		'<p style=color:#fff;><span style="margin-right: 5px;border-radius: 5px; display: block;width: 40px;height: 20px;background-color: #EE6666;"></span>' +
						// 			val +
						// 			'<span style="color: #EE6666;margi:0 10px;">' +
						// 			this.allstatussta.OfflineCount ??
						// 		'' + '</span>台' + this.allstatussta.OfflineCountUsage ??
						// 		'' + '%</p>';
						// }
						return val;
					}
				},
				series: [
					{
						name: '实时设备状态统计',
						type: 'pie',
						radius: ['40%', '90%'],
						center: ['40%', '50%'],
						avoidLabelOverlap: true,
						label: {
							show: false,
							position: 'center',
							formatter: val => {
								// console.log(val,'获取图标信息')
								return val.name;
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [
							{
								value: 1500,
								name: '维修中',
								itemStyle: {
									color: '#EE6666'
								}
							},
							{
								value: 742,
								name: '空闲中',
								itemStyle: {
									color: '#5470C6'
								}
							},
							{
								value: 1000,
								name: '离线中',
								itemStyle: {
									color: '#FAC858'
								}
							},
							{
								value: 2721,
								name: '使用中',
								itemStyle: {
									color: '#91CC75'
								}
							}
						]
					}
				]
			},
			myCharts1: {},
			optionsb3: {},
			optionsb1: {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: '4%',
					top: '20%',
					textStyle: {
						color: '#fff'
					}
				},
				series: [
					{
						name: '设备使用情况分析',
						type: 'pie',
						radius: '75%',
						left: 'center',
						avoidLabelOverlap: false,
						center: ['65%', '55%'],
						label: {
							show: true,
							position: 'outside',
							formatter: '{b} {d}%({c})',
							textStyle: {
								fontSize: '12',
								fontWeight: '400',
								color: '#fff'
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '16',
									fontWeight: '400',
									color: '#fff'
								}
							}
						},
						labelLine: {
							show: true,
							length: 5,
							length2: 5
						},
						color: ['#91CC75', '#5470C6'],
						data: [
							{
								value: 0,
								name: '空闲'
							},
							{
								value: 10,
								name: '使用中'
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},
			options3: {
				grid: {
					top: '20%',
					left: '2%',
					right: '2%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					}
				},
				yAxis: {
					type: 'value',
					// name: '单位（人）',
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						},
						formatter: '{value} 人'
					},
					splitLine: {
						//网格线
						lineStyle: {
							type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
						},
						show: true //隐藏或显示
					},
					min: 0, // 起始
					max: 0 // 终止
				},

				series: [
					{
						data: [],
						type: 'bar',
						color: '#FADB71',
						label: {
							//数值显示
							show: true, //显示柱状图上每一列的数值
							rotate: 20, //让显示的数值进行旋转
							position: 'inside' ,//标签的位置
							textStyle: {
								color: '#000'
							}
						},
						
						emphasis: {
							focus: 'series', // 在高亮图形时，是否淡出其它数据的图形已达到聚焦的效果。默认值'none'不淡出其它图形，series' 聚焦当前高亮的数据所在的系列的所有图形，'self' 只聚焦（不淡出）当前高亮的数据的图形
							label: {
								show: true
							}
						}
					}
				]
			},
			siguids: '',
			// ===== 模拟数据开关 =====
			siguidnewlogins: '',
			openbtntext: false,
			mockEnable: false,
			siguidMockDataMap: getMockDataMap(),
			// ===== 模拟数据开关 end =====
			alltrainsnumobj: {},
			allstatussta: {},
			autolocation: {},
			appoindatalist: [],
			pageSize: 20,
			allistyears: '',
			dataname: [],
			datayearname: [],
			serieslist: [],
			serieslistdata: []
		};
	},
	watch: {
		allistyears(val) {
			if (val == '') {
				this.getlistyears();
			}
		}
	},
	beforeCreate() {
		AppOptions.appEmpty = true;
	},
	created() {},
	mounted() {
		this.siguids = this.$route.query.siguid;
		// 判断当前院校是否开放「开启 / 关闭」模拟数据开关
		// 优先取地址栏上的院校（跨院校查看时 localStorage 里是登录用户自己的院校）
		this.siguidnewlogins = this.siguids || localStorage.getItem('siguid');
		this.mockEnable = MOCK_SCHOOL_GUIDS.includes(this.siguidnewlogins) || localStorage.getItem('datawallMock') === '1';
		this.charts();

		this.getlistyears(); // 使用时长分析
		this.getLocation(); // 获取定位信息
		this.getTime(); // 获取时间
		// 再dom生产之后再产生数据
		this.$nextTick(() => {
			this.getsingledata(); // 获取滚动
			this.gettarinclas();
			this.getdatalist();
		});
		this.gettrainsta();
		this.gettraincount();
		this.gettraaineqstatus();
		this.changescharts3();
	},
	computed: {
		// 当前院校的模拟数据配置
		getCurrentMockData() {
			if (!this.mockEnable) return null;
			return this.siguidMockDataMap[this.siguidnewlogins] || null;
		},
		classOption1() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: this.appointmentlist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: this.deviceranklist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption3() {
			return {
				step: 0.1, // 数值越大速度滚动越快
				limitMoveNum: this.appoindatalist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		}
	},

	methods: {
		// 开启 / 关闭 模拟数据
		openbtnshowtext() {
			this.openbtntext = !this.openbtntext;
			const mockData = this.getCurrentMockData;

			if (this.openbtntext) {
				if (!mockData) {
					// 该院校没有配置模拟数据，保持真实接口数据
					this.openbtntext = false;
					return;
				}

				// 累计实训时长 / 实训室总数 / 实训设备总数 / 实训人数
				this.alltrainsnumobj = Object.assign({}, this.alltrainsnumobj, mockData.alltrainsnumobj);

				// 本周实训人数统计
				this.setmocktraincount(mockData.datacountlist);

				// 个人实训排行榜
				this.userslist = (mockData.userslist || []).map(item => Object.assign({}, item));

				// 实时预约数据
				if (mockData.appoindatalist) {
					let timers = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate();
					this.appoindatalist = mockData.appoindatalist.map(item => Object.assign({}, item, { ap_appDate: timers }));
				}

				// 使用时长分析（列表 + 图表）
				if (mockData.listyearsData) {
					this.getlistyears(mockData.listyearsData);
				}
			} else {
				// 关闭：恢复真实接口数据
				this.alltrainsnumobj = {};
				this.userslist = [];
				this.appoindatalist = [];
				this.gettrainsta();
				this.gettraincount();
				this.gettraaineqstatus();
				this.changescharts3();
				this.$nextTick(() => {
					this.getsingledata();
					this.gettarinclas();
					this.getdatalist();
				});
				this.getlistyears();
			}
		},

		// 本周实训人数统计（模拟数据）
		setmocktraincount(countlist) {
			if (!countlist || countlist.length == 0) return;
			this.options3.series[0].data = countlist;
			this.options3.yAxis.max = Math.max.apply(null, countlist) + 3;
			if (this.myCharts4) {
				this.myCharts4.setOption(this.options3);
			}
		},

		charts() {
			let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('pic1'));
			// console.log(myCharts1,"charts1")
			if (myCharts1 == null) {
				myCharts1 = this.$echarts.init(document.getElementById('pic1'));
			}
			this.myCharts1 = myCharts1;
			myCharts1.setOption(this.option1);

			let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('pic2'));
			if (myCharts2 == null) {
				myCharts2 = this.$echarts.init(document.getElementById('pic2'));
			}
			this.myCharts2 = myCharts2;

			let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('pic3'));
			if (myCharts3 == null) {
				myCharts3 = this.$echarts.init(document.getElementById('pic3'));
			}
			myCharts3.setOption(this.optionsb1);
			this.myCharts3 = myCharts3;

			let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('pic4'));
			if (myCharts4 == null) {
				myCharts4 = this.$echarts.init(document.getElementById('pic4'));
			}
			myCharts4.setOption(this.options3);
			this.myCharts4 = myCharts4;
			window.addEventListener('resize', function() {
				myCharts1.resize();
				myCharts2.resize();
				myCharts3.resize();
				myCharts4.resize();
			});
		},
		handleClick(e) {
			const path = e.path || (e.composedPath && e.composedPath());
			let target = path.filter(r => /listItem/.test(r.className));
			if (target.length) target = target[0];
			else return;
			const data = JSON.parse(target.getAttribute('data')); // 单项数据详情
			console.log(data);
			if (data.cla_guid == null) {
				this.$message('该同学暂无班级！');
			} else {
				this.$router.push('/datawall/datawalluser?siguid=' + this.siguids + '&cla_guid=' + data.cla_guid + '&ui_guid=' + data.ui_guid);
			}
		},
		getdatalist() {
			let appontobj = {
				pageIndex: 1,
				pageSize: this.pageSize,
				si_guid: this.siguids
			};
			let timer = null;
			GetPageAppointDataList(appontobj).then(res => {
				// console.log(res)
				if (res) {
					this.appoindatalist = res.data.data.list;
				} else {
				}
			});
		},

		gettarinclas() {
			let timer = null;
			// GetTrainClassDataList(this.siguids).then(res => {
			GetTrainClassDataListNewAPi(this.siguids).then(res => {
				// console.log(res)
				if (res) {
					this.appointmentlist = res.data.data;
				} else {
				}
			});
		},

		getsingledata() {
			let timer = null;
			// GetTrainSingleDataList(this.siguids).then(res => {
			GetTrainSingleDataListNewApi(this.siguids).then(res => {
				// console.log(res)
				if (res) {
					this.userslist = res.data.data;
				} else {
				}
			});
		},

		// 获取定位
		getLocation() {
			const _this = this;
			var autolocation = {};
			AMap.plugin('AMap.CitySearch', function() {
				var citySearch = new AMap.CitySearch();
				// console.log('获取定位信息', citySearch);
				citySearch.getLocalCity(function(status, result) {
					// console.log('获取定位信息', status, result);
					if (status === 'complete' && result.info === 'OK') {
						_this.autolocation = result;
						_this.getweater(result);
					}
				});
			});
		},
		getweater(autol) {
			// console.log('autol》》》》地理', autol);
			getweathers(autol.city).then(res => {
				console.log('天气》》》》》', res);
				let wetherobjs = {
					weather: res.results[0].now.text,
					temperature: res.results[0].now.temperature,
					city: res.results[0].location.name
				};
				this.weatherobj = wetherobjs;
				this.weatherobj.weatherimg = require('@/assets/weather/阴.png');
				// console.log(this.weatherobj)
				var findWeatherItem = '';
				const iconWeatherMap = {
					风: ['有风', '平静', '微风', '和风', '清风', '强风/劲风', '疾风', '大风', '烈风', '风暴', '狂爆风', '飓风', '热带风暴', '龙卷风'],
					多云: ['少云', '晴间多云', '多云'],
					雪: ['雪', '阵雪', '小雪', '中雪', '大雪', '暴雪', '小雪-中雪', '中雪-大雪', '大雪-暴雪', '冷'],
					雾: ['浮尘', '扬沙', '沙尘暴', '强沙尘暴', '雾', '浓雾', '强浓雾', '轻雾', '大雾', '特强浓雾'],
					晴: ['晴', '热'],
					雨夹雪: ['雨雪天气', '雨夹雪', '阵雨夹雪'],
					雨: [
						'阵雨',
						'雷阵雨',
						'雷阵雨并伴有冰雹',
						'小雨',
						'中雨',
						'大雨',
						'暴雨',
						'大暴雨',
						'特大暴雨',
						'强阵雨',
						'强雷阵雨',
						'极端降雨',
						'毛毛雨/细雨',
						'雨',
						'小雨-中雨',
						'中雨-大雨',
						'大雨-暴雨',
						'暴雨-大暴雨',
						'大暴雨-特大暴雨',
						'冻雨'
					],
					阴: ['阴', '霾', '中度霾', '重度霾', '严重霾', '未知']
				};

				for (let thear in iconWeatherMap) {
					const weatherNames = iconWeatherMap[thear];
					findWeatherItem = weatherNames.find(name => this.weatherobj.weather === name);
					// 如果找了某一类的图标了，那重新赋值url
					if (findWeatherItem) {
						// 这里的weatherKey和icon的名字一一对应了
						this.weatherobj.weatherimg = require(`@/assets/weather/${thear}.png`);
						break;
					}
				}
				// console.log(this.weatherobj, '天气系统');
			});

			// getCity(autol.adcode).then(res => {
			// 	// console.log('天气》》》》》', res);
			// 	this.weatherobj = res.lives[0];
			// 	this.weatherobj.weatherimg = require('@/assets/weather/阴.png');
			// 	// console.log(this.weatherobj)
			// 	var findWeatherItem = '';
			// 	const iconWeatherMap = {
			// 		风: ['有风', '平静', '微风', '和风', '清风', '强风/劲风', '疾风', '大风', '烈风', '风暴', '狂爆风', '飓风', '热带风暴', '龙卷风'],
			// 		多云: ['少云', '晴间多云', '多云'],
			// 		雪: ['雪', '阵雪', '小雪', '中雪', '大雪', '暴雪', '小雪-中雪', '中雪-大雪', '大雪-暴雪', '冷'],
			// 		雾: ['浮尘', '扬沙', '沙尘暴', '强沙尘暴', '雾', '浓雾', '强浓雾', '轻雾', '大雾', '特强浓雾'],
			// 		晴: ['晴', '热'],
			// 		雨夹雪: ['雨雪天气', '雨夹雪', '阵雨夹雪'],
			// 		雨: [
			// 			'阵雨',
			// 			'雷阵雨',
			// 			'雷阵雨并伴有冰雹',
			// 			'小雨',
			// 			'中雨',
			// 			'大雨',
			// 			'暴雨',
			// 			'大暴雨',
			// 			'特大暴雨',
			// 			'强阵雨',
			// 			'强雷阵雨',
			// 			'极端降雨',
			// 			'毛毛雨/细雨',
			// 			'雨',
			// 			'小雨-中雨',
			// 			'中雨-大雨',
			// 			'大雨-暴雨',
			// 			'暴雨-大暴雨',
			// 			'大暴雨-特大暴雨',
			// 			'冻雨'
			// 		],
			// 		阴: ['阴', '霾', '中度霾', '重度霾', '严重霾', '未知']
			// 	};

			// 	for (let thear in iconWeatherMap) {
			// 		const weatherNames = iconWeatherMap[thear];
			// 		findWeatherItem = weatherNames.find(name => this.weatherobj.weather === name);
			// 		// 如果找了某一类的图标了，那重新赋值url
			// 		if (findWeatherItem) {
			// 			// 这里的weatherKey和icon的名字一一对应了
			// 			this.weatherobj.weatherimg = require(`@/assets/weather/${thear}.png`);
			// 			// console.debug('@find weather key = ', weatherKey)
			// 			break;
			// 		}
			// 	}
			// 	// console.log(this.weatherobj, '天气系统');
			// });
		},

		gettraaineqstatus() {
			let timer = null;
			GetTrainEquipmentStatusSTA(this.siguids).then(res => {
				if (res) {
					this.allstatussta = res.data.data;
					this.option1.series[0].data[0].value = res.data.data.OfflineCount;
					this.option1.series[0].data[1].value = res.data.data.IdleCount;
					this.option1.series[0].data[2].value = res.data.data.RepairCount;
					this.option1.series[0].data[3].value = res.data.data.UsingCount;
					// console.log(this.allstatussta,"设备状态")
					this.myCharts1.setOption(this.option1);

					// timer = setTimeout(() => {
					// 	this.gettraaineqstatus();
					// }, 1800000); //30分钟查一下
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		gettraincount() {
			// console.log(new Date().getFullYear() + "/"+(new Date().getMonth()+1)+"/"+new Date().getDate())
			let timers = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate();
			let countobj = {
				si_guid: this.siguids,
				time: timers
			};
			let timer = null;
			// DataWallGetTrainCount(countobj).then(res => {
			GetTrainCountNewCountApi(countobj).then(res => {
				// console.log(res)
				let datelist = [];
				let countlist = [];
				if (res) {
					res.data.data.forEach(item => {
						datelist.push(item.date);
						countlist.push(item.count);
					});
					let maxs = Math.max(...countlist);
					// console.log(maxs, '最大值');
					this.options3.yAxis.max = maxs + 3;

					this.options3.xAxis.data = datelist;
					this.options3.series[0].data = countlist;
					this.myCharts4.setOption(this.options3);
					// timer = setTimeout(() => {
					// 	this.gettraincount();
					// }, 1800000); //2秒查一下
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		gettrainsta() {
			let timer = null;
			// DataWallGetTrainSTA(this.siguids).then(res => {
			GetTrainSTANewAPI(this.siguids).then(res => {
				if (res) {
					this.alltrainsnumobj = res.data.data;
					this.alltrainsnumobj.trainTime = Math.round(res.data.data.trainTime);
				} else {
				}
			});
		},
		gouserwall() {
			this.$router.push('/datawall/datawalluser');
		},
		changescharts3() {
			let optionper = {
				si_guid: this.siguids,
				month: new Date().getMonth() + 1
			};
			let timer = null;

			GetTrainUsageSTA(optionper).then(res => {
				// console.log(res.data.data, "使用率分析")
				if (res) {
					this.optionsb1.series[0].data[0].value = Math.round((100 - res.data.data) * 100) / 100;
					this.optionsb1.series[0].data[1].value = res.data.data;
					// console.log(this.optionsb1)
					this.myCharts3.setOption(this.optionsb1);
					// timer = setTimeout(() => {
					// 	this.changescharts3();
					// }, 1800000); //30分钟查一下
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		// allistdata：开启模拟数据时传入的模拟数据
		getlistyears(allistdata) {
			var dataname = [];
			var datayearname = [];
			var serieslist = [];
			let that = this;
			let serieslistdata = [];
			let datalistall = [];
			// GetTrainTimeLengthDataList(this.siguids).then(res => {
			GetTrainTimeLengthDataListNewApi(this.siguids).then(res => {
				// console.log(res, '使用时长分析');
				var timer = null;
				// 开启模拟数据时用模拟数据，否则用接口数据
				if (allistdata && this.openbtntext) {
					that.allistyears = allistdata;
				} else if (res && res.data && res.data.data) {
					that.allistyears = res.data.data;
					// timer = setTimeout(() => {
					// 	this.getlistyears();
					// }, 1800000); //30分钟查一下
				} else {
					// clearTimeout(timer); //清理定时任务
					that.allistyears = { listyear: [], listYear: {} };
				}
				if (!that.allistyears || !that.allistyears.listyear || !that.allistyears.listYear) {
					that.allistyears = { listyear: [], listYear: {} };
				}

				that.allistyears.listyear.forEach((item, index) => {
					if (item.te_deviceName) {
						dataname.push(item.te_deviceName);
						serieslist.push({
							name: item.te_deviceName,
							type: 'bar'
						});
						for (var yearname in item) {
							if (yearname !== 'te_deviceName') {
								datayearname.push(yearname.slice(0, 4));
							}
						}
					}
				});

				serieslist.push({
					type: 'pie',
					center: ['80%', '20%'],
					radius: '20%',
					z: 100,
					label: {
						color: '#fff',
						//字体大小
						fontSize: 18
					}
				});

				datayearname = Array.from(new Set(datayearname));

				let parename = {};

				let datalistallav = [];
				datayearname.forEach(item => {
					that.allistyears.listyear.forEach((ite, inde) => {
						if (ite.te_deviceName) {
							for (var yearname in ite) {
								if (yearname.slice(0, 4) == item) {
									// datalistall.push(parename)
									parename[item] = [];
								}
							}
						}
					});
				});

				for (var yearmea in that.allistyears.listYear) {
					that.allistyears.listYear[yearmea].forEach(item => {
						item.value = item.accounted;
						item.name = item.te_deviceName;
					});
				}

				for (var keys in parename) {
					that.allistyears.listyear.forEach((ite, inde) => {
						if (ite.te_deviceName) {
							for (var yearname in ite) {
								if (yearname.slice(0, 4) == keys) {
									// datalistall.push(parename)
									parename[keys].push(ite[yearname]);
								}
							}
						}
					});
				}
				// console.log(parename)
				for (var keys in parename) {
					parename[keys] = this.changelsits(parename[keys], 12);
				}

				for (var keys in parename) {
					parename[keys].forEach((item, index) => {
						parename[keys][index] = {
							data: item,
							itemStyle: {
								normal: {
									color: function(params) {
										let colorList = [
											'#91CC75',
											'#0063B5',
											'#FFCECE',
											'#BDDE7B',
											'#8CD6CE',
											'#94B5E7',
											'#5ABDEF',
											'#FFCE4A',
											'#B5ADD6',
											'#F7946B',
											'#9C3939',
											'#006B73'
										];
										let colorItem = colorList[index];
										return colorItem;
									}
								}
							}
						};
						// console.log(parename[keys][index], '这里是什么东西');
					});
					parename[keys].push({
						data: this.allistyears.listYear[keys],
						itemStyle: {
							normal: {
								color: function(params) {
									let colorList = ['#91CC75', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'];
									let colorItem = colorList[params.dataIndex];
									return colorItem;
								}
							}
						}
					});
				}
				// console.log(parename)

				for (var keys in parename) {
					serieslistdata.push({
						title: {
							text: keys + '年设备实训时长统计',
							textStyle: {
								//文字颜色
								color: '#fff',
								//字体大小
								fontSize: 20
							}
						},
						series: parename[keys]
					});
				}

				// console.log(serieslistdata, '获取当前图表');
				// console.log("设备名字", dataname)
				this.dataname = dataname;
				// console.log("年份名字", datayearname)
				this.datayearname = datayearname;
				// console.log("统计设备", serieslist)
				this.serieslist = serieslist;
				console.log('统计数据', serieslistdata);

				this.serieslistdata = serieslistdata;
				this.setcharts();
			});
		},
		// 循环数组得到值
		changelsits(datalistall, pers) {
			var allData = []; //用来装处理完的数组
			var currData = []; //子数组用来存分割完的数据
			//循环需要处理的数组
			for (var i = 0; i < datalistall.length; i++) {
				//将chartArr[i]添加到子数组
				currData.push(datalistall[i]);
				//在这里求4的余数,如果i不等于0,且可以整除 或者考虑到不满4个或等于4个的情况就要加上  i等于当前数组长度-1的时候
				if ((i != 0 && (i + 1) % pers == 0) || i == datalistall.length - 1) {
					//把currData加到allData里
					allData.push(currData);
					//在这里清空currData
					currData = [];
				}
			}
			return allData;
		},

		setcharts() {
			let options = {
				color: ['#91CC75', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
				baseOption: {
					timeline: {
						bottom: '2%',
						axisType: 'category',
						autoPlay: true,
						playInterval: 7000,
						data: this.datayearname,
						label: {
							formatter: function(s) {
								return new Date(s).getFullYear();
							}
						}
					},
					title: {
						left: '9%',
						subtext: '数据来自综合实训管理平台',
						subtextStyle: {
							color: '#ccc',
							//字体大小
							fontSize: 14
						}
					},
					tooltip: {},
					legend: {
						show: false,
						right: '5%',
						data: this.dataname,
						textStyle: {
							//文字颜色
							color: '#fff',
							//字体大小
							fontSize: 16
						}
					},
					calculable: true,
					grid: {
						top: 60,
						bottom: 100,
						left: '5%',
						right: '3%',
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow',
								label: {
									show: true,
									formatter: function(params) {
										return params.value.replace('\n', '');
									}
								}
							}
						}
					},
					xAxis: [
						{
							type: 'category',
							axisLabel: {
								interval: 0
							},
							data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
							splitLine: {
								show: false
							},
							axisLabel: {
								textStyle: {
									show: true,
									fontFamily: '微软雅黑',
									color: '#fff'
								}
							}
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '时长（小时）',
							nameTextStyle: {
								color: '#fff'
							},
							axisLabel: {
								textStyle: {
									show: true,
									fontFamily: '微软雅黑',
									color: '#fff'
								}
							}
						}
					],
					series: this.serieslist
				},
				options: this.serieslistdata
			};

			// var myCharts2 = this.$echarts.init(document.getElementById('pic2'));
			// // console.log(myCharts2)
			// this.myCharts2 = myCharts2
			this.optionsb3 = options;
			this.myCharts2.setOption(this.optionsb3);
		},

		dataFormatter(obj) {
			// prettier-ignore
			var pList = ['1月',
					'2月',
					'3月',
					'4月',
					'5月',
					'6月',
					'7月',
					'8月',
					'9月',
					'10月',
					'11月',
					'12月'
				];
			var temp;

			for (var year = 0; year <= this.datayearname.length - 1; year++) {
				var max = 0;
				var sum = 0;
				temp = obj[year];
				for (var i = 0, l = temp.length; i < l; i++) {
					max = Math.max(max, temp[i]);
					sum += temp[i];
					obj[year][i] = {
						name: pList[i],
						value: temp[i]
					};
				}
				obj[year + 'max'] = Math.floor(max / 100) * 100;
				obj[year + 'sum'] = sum;
			}
			return obj;
		},
		getTime() {
			this.timer = setInterval(() => {
				let timeDate = new Date();
				let year = timeDate.getFullYear();
				let mounth = timeDate.getMonth() + 1;
				let day = timeDate.getDate();
				let hours = timeDate.getHours();
				hours = hours >= 10 ? hours : '0' + hours;
				let minutes = timeDate.getMinutes();
				minutes = minutes >= 10 ? minutes : '0' + minutes;
				let seconds = timeDate.getSeconds();
				seconds = seconds >= 10 ? seconds : '0' + seconds;
				let week = timeDate.getDay();
				let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

				this.nowTime = ` ${hours}:${minutes}:${seconds} `;

				this.yeartimer = `${year}/${mounth}/${day}  ${weekArr[week]}`;
			}, 1000);
		}
	},
	components: {
		vueSeamlessScroll,
		numbergrow,
		sacleBox
	}
};
</script>
<style>
.theme-teal {
	background-color: #142131 !important;
}
</style>

<style scoped lang="less">
.scrols {
	ul {
		margin-top: 0 !important;
	}
}

p {
	font-family: '微软雅黑', '微软雅黑 Regular';
}

.nomolflex {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
}

.comenteflex {
	display: flex;
	flex-direction: column;
}

.appconten {
	background: url('../../images/datetolines.png') no-repeat center/101% 101%;
	// background-size: 100% auto;
	width: 100%;
	height: 100vh;
	box-sizing: border-box;
	overflow: hidden;
}

.lines {
	height: 100%;
}

.appconten {
	height: 100%;
	display: flex;
	justify-items: space-between;
}

.appleft,
.appright {
	width: 25%;
}

.appright {
	padding: 0 10px;
	height: 100%;
}

.appcenter {
	width: 50%;
	padding: 0 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
}

.trainstitle p {
	color: #fff;
	font-family: '微软雅黑 ', '微软雅黑 Regular';
	// font-weight: 700;
	font-style: normal;
	font-size: 48px;
	color: rgb(205, 221, 247);
	border-width: 0px;
	text-align: center;
	transform: translateY(-76px);
}

.trainstitle {
	width: 100%;
	padding: 20px 0 0 0;
	height: 100px;
	box-sizing: border-box;
}

.trainstitle img {
	width: 100%;
}

.trainsweather {
	width: 100%;
	height: 12%;
}

.trainsweather .trainsbox {
	border: 1px solid #0e94ea;
	width: 50%;
	height: 100px;
	border-radius: 2px;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-items: first baseline;
}

.trainsweather .trainsboxleft {
	padding: 0 10px;
	border-right: 1px solid #ffffff;
	width: 50%;
}

.trainsboxright {
	display: flex;
	align-items: center;
	margin-left: 30px;

	p {
		font-size: 1rem;
	}
}

.dataline {
	transform: translateX(-80px);
	height: 80%;
}

.trainsall {
	transform: translateX(-98%);
}

.trainsimg {
	width: 100%;
	height: 88%;
	margin-top: 10px;
	border-radius: 2px;
	/* border: 1px solid #0E94EA; */
}

.trainsimg img {
	width: 100%;
	height: 100%;
	border-radius: 2px;
}

.trainsall p {
	margin: 10px 0;
	font-weight: 700;
	font-style: normal;
	font-size: 18px;
	color: #ffff00;
}

.trainsweather .trainsboxleft p:first-child {
	font-weight: 400;
	font-style: normal;
	font-size: 42px;
	color: #cdddf7;
}

.trainsweather .trainsboxleft p:last-child {
	font-weight: 400;
	font-style: normal;
	font-size: 18px;
	color: rgb(205, 221, 247);
	border-width: 0px;
}

.appleft {
	padding: 20px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.applefttitle {
	text-align: center;
	width: 100%;
	height: 18%;
	background: url('../../images/datebig.png') no-repeat center;
	background-size: 100% auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.lefttitilefonts {
	color: rgb(14, 148, 234);
	transform: translateY(-10px);
	font-weight: 700;
	font-style: normal;
	font-size: 18px;
}

.fontsanum {
	font-weight: 400;
	font-style: normal;
	font-size: 60px;
	color: #ffffff;

	/deep/ .number-grow {
		font-size: 60px;
		color: #ffffff;
	}
}

.appcenter {
	margin-top: 0.4rem;
}

.appleftcenter {
	width: 100%;
	height: 5%;
}

.appleftcenter img {
	width: 100%;
}

.appleftcenter {
	margin-top: 1rem;
}

.appleftfonts {
	font-family: '幼圆';
	font-weight: 400;
	font-style: normal;
	font-size: 22px;
	color: rgb(255, 255, 255);
	transform: translate(40px, -35px);
}

.applefecharts {
	width: 100%;
	display: flex;
	/* align-items: center; */
	justify-content: flex-start;
}

.applefecharts .echartsm p {
	display: flex;
	align-items: center;
	color: #fff !important;
	margin-top: 30px;
}

.echartsa {
	width: 90%;
	height: 240px;
}

.trainsb {
	height: 24%;
	overflow: hidden;
}

.trainsb ul {
	width: 100%;
	// height: 100%;
	// max-height: 310px;
	// overflow: hidden;
	overflow-y: scroll;
}

.trainsb ul li span {
	margin-right: 10px;
}

.trainsb ul li:nth-of-type(1) p:first-child {
	background-color: #ed405d;
	padding: 10px;
}

.trainsb ul li:nth-of-type(2) p:first-child {
	background-color: #f78c44;
	padding: 10px;
}

.trainsb ul li:nth-of-type(3) p:first-child {
	background-color: #49bcf7;
	padding: 10px;
}

// .trainsb ul li:first-child {
// 	border-bottom: 1px solid #fff;
// }

.trainsb ul::-webkit-scrollbar {
	display: none;
}

.trainsb ul li {
	display: flex;
	width: 100%;
	margin: 10px 0;
	/* border: 1px solid #0E94EA; */
}

.trainsb ul li p {
	width: 33.3%;
	// padding: 10px 0;
	line-height: 30px;
	height: 30px;
	text-align: center;
	// border: 1px solid #0E94EA;
	color: #fff;
	border-bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
}

.trainsb ul li p:first-child {
	width: 8% !important;
	background-color: #878787;
}

// .trainsb ul li:last-child {
// 	border-bottom: 1px solid #0E94EA;
// }

.trainsb ul li p img {
	width: 30px;
	height: 30px;
	vertical-align: middle;
}

.trainspic2 {
	width: 100%;
	// min-height: 280px;
	// max-height: calc(240px + 100px);
	height: 100%;
	/* border: 1px solid; */
	margin-top: 10px;
}

.trainspic3 {
	height: 100%;
}

.years {
	margin-top: 20px;
	color: #e0e0d8;
	font-size: 20px;
	letter-spacing: 1px;
}

.traingety ul {
	margin-top: 18px;
	overflow: scroll;
}

.traingety ul::-webkit-scrollbar {
	display: none;
}

.traingety li {
	height: 40px;
	text-align: center;
	color: #fff;
	width: 100%;
}

// .traingety li:first-child p {
// 	color: #FFFFED;
// 	font-weight: 700;
// }

// .traingety li:not(li:first-child) {
// 	border-bottom: 1px dashed #ccc;
// }

/* 开启 / 关闭 模拟数据按钮 */
.openclosebtn {
	position: fixed;
	top: 14px;
	right: 0;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	font-size: 14px;
	color: #fff;
	background-color: #0e94ea;
	cursor: pointer;
	z-index: 9999;
}

.openclosebtn:hover {
	color: #ed405d;
}
</style>
